import styled from 'styled-components';

export const StyledDiv = styled.div`
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
`;

export const StyledIcon = styled.img`
  width: 40px !important;
  height: 31px !important;
  padding: 20px !important;
`;
